module.exports = __webpack_public_path__ + "img/jx.b7ad09b9.jpg";